import {
  IRoutingConfigVersion,
  IRoutingVersionsTableColumns,
} from '@entities/routing/config-version';
import RoutingVersionStatusBadge from '@shared/components/RoutingVersionStatusBadge';
import { parseUtcDateTime } from '@shared/utils/parseUtcDateTime';

import { ActorLabel } from '../../components/ActorLabel';

// TBody requires a string id; the API returns numeric version ids.
export interface IRoutingVersionRow extends Omit<IRoutingConfigVersion, 'id'> {
  id: string;
}

export const useTableSettings = () => {
  const columnTitles: IRoutingVersionsTableColumns = {
    version: 'Version',
    name: 'Name',
    status: 'Status',
    author: 'Author',
    created_at: 'Created At',
    published_at: 'Published At',
    comment: 'Comment',
  };

  const renderItem = (key: keyof IRoutingVersionsTableColumns, version: IRoutingVersionRow) => {
    switch (key) {
      case 'version':
        return <span className='routing-version-number'>v{version.id}</span>;
      case 'name':
        return version.name;
      case 'status':
        return <RoutingVersionStatusBadge status={version.status} />;
      case 'author':
        return <ActorLabel actor={version.created_by} />;
      case 'created_at':
        return parseUtcDateTime(version.created_at).toLocaleString();
      case 'published_at':
        return version.published_at ? new Date(version.published_at).toLocaleString() : '—';
      case 'comment': {
        const policiesOn = version.policies.filter(policy => policy.active).length;
        return (
          <>
            <div>{version.comment || '—'}</div>
            {version.policies.length > 0 && (
              <div className='routing-version-policies-note'>
                {policiesOn} of {version.policies.length} policies on
              </div>
            )}
          </>
        );
      }
      default:
        return null;
    }
  };

  return { columnTitles, renderItem };
};
